import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import { Device } from 'DeviceUtils';

const baseStyles = {
    container: {
        flex: 1,
        alignSelf: 'stretch',
        alignItems: 'center',
        flexDirection: 'column',
        paddingHorizontal: Theme.primaryMargin,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        height: '100%'
    },
    scrollView: {
        width: Device.isWeb ? 510 : '100%',
        flex: 1
        // paddingTop: 20
    },
    scrollContainer: {
        height: '100%',
        justifyContent: 'center',
        paddingBottom: 60,
        paddingTop: 50
    },
    title: {
        ...fontStyles.title,
        alignSelf: 'center',
        marginBottom: '2%'
    },
    recordingOnContainer: {
        marginTop: 40,
        marginBottom: 30,
        height: 30,
        alignItems: 'flex-start',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    recordingOnIcon: {
        marginVertical: 5,
        marginHorizontal: 10,
        width: 20,
        height: 20
    },
    recordingOnText: {
        color: Theme.primaryTextColor,
        fontSize: 18,
        lineHeight: 30
    },
    grayText: {
        marginTop: 10,
        color: Theme.secondaryTextColor,
        fontSize: 16
    },
    description: {
        alignSelf: 'center',
        marginVertical: 10,
        color: Theme.secondaryTextColor,
        fontSize: Theme.fontSizes.description,
        textAlign: 'center'
    },
    separator: {
        marginTop: '3%',
        marginBottom: 20
    }
};

if (Device.isTabletOrWeb) {
    baseStyles.scrollContainer = {
        ...baseStyles.scrollContainer,
        paddingBottom: 0
    };
}

export default StyleSheet.create(baseStyles);
